import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7b943dca&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=7b943dca&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b943dca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/samuelscn/Área de Trabalho/veins/veins-api/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b943dca')) {
      api.createRecord('7b943dca', component.options)
    } else {
      api.reload('7b943dca', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7b943dca&scoped=true", function () {
      api.rerender('7b943dca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/components/power-plant/index.vue"
export default component.exports